/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */

export class StatusRequest {


    public paymentId: number;
    public status: number;

     constructor(statusRequest: any) {
         this.paymentId = statusRequest.paymentId || '';
         this.status = statusRequest.status || 0;
     }
 }
